import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Alert } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // ✅ for redirect

const Login = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [message, setMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("info");

  const backendURL = "http://localhost:5000"; // your backend
  const navigate = useNavigate(); // ✅ navigation hook

  const sendOtp = async () => {
    if (!phone || phone.length < 10) {
      setMessage("Please enter a valid 10-digit phone number.");
      setAlertVariant("danger");
      return;
    }
    try {
      const res = await axios.post(`${backendURL}/send-otp`, { phone });
      setMessage(res.data.message);
      setAlertVariant("success");
      setOtpSent(true);
    } catch (err) {
      setMessage(err.response?.data?.error || "Failed to send OTP");
      setAlertVariant("danger");
    }
  };

  const verifyOtp = async () => {
    if (!otp) {
      setMessage("Please enter the OTP.");
      setAlertVariant("danger");
      return;
    }
    try {
      const res = await axios.post(`${backendURL}/verify-otp`, { phone, otp });
      setMessage(res.data.message);
      setAlertVariant(res.data.success ? "success" : "danger");

      if (res.data.success) {
        // ✅ redirect to feedback page
        setTimeout(() => {
          navigate("/feedback");
        }, 1500);
      }

      setOtpSent(false);
      setOtp("");
      setPhone("");
    } catch (err) {
      setMessage(err.response?.data?.message || "Invalid OTP");
      setAlertVariant("danger");
    }
  };

  return (
    <div className="fade-in">
      {/* Hero Header Section */}
      <section
        className="py-5 mt-5 text-white"
        style={{
          background: "linear-gradient(135deg, #2E8B57, #4682B4)",
        }}
      >
        <Container style={{ marginTop: "50px" }}>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-5 fw-bold mb-3">Login via OTP</h1>
              <p className="fs-5">
                Secure and easy login using your registered mobile number
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Login Form Section */}
      <section className="section-padding">
        <Container className="mt-5">
          <Row className="justify-content-center">
            <Col md={6} lg={5}>
              <Card className="shadow-lg border-0">
                <Card.Body className="p-5">
                  <h3 className="fw-bold mb-4 text-center">OTP Login</h3>

                  {message && (
                    <Alert variant={alertVariant} className="text-center">
                      {message}
                    </Alert>
                  )}

                  {!otpSent ? (
                    <>
                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold">
                          Mobile Number *
                        </Form.Label>
                        <Form.Control
                          type="tel"
                          placeholder="Enter 10-digit mobile number"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          maxLength="10"
                          className="p-3 border-0 bg-light"
                        />
                      </Form.Group>

                      <Button
                        onClick={sendOtp}
                        className="btn-primary-custom w-100 py-2"
                      >
                        Send OTP
                      </Button>
                    </>
                  ) : (
                    <>
                      <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold">
                          Enter OTP *
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter the OTP received"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          className="p-3 border-0 bg-light"
                        />
                      </Form.Group>

                      <Button
                        onClick={verifyOtp}
                        className="btn-success w-100 py-2"
                      >
                        Verify OTP
                      </Button>

                      <div className="text-center mt-3">
                        <Button
                          variant="link"
                          onClick={() => {
                            setOtpSent(false);
                            setOtp("");
                            setMessage("");
                          }}
                        >
                          Resend OTP
                        </Button>
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer Info Section */}
      <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h4 className="fw-bold mb-3">Why Secure Login?</h4>
              <p className="text-muted">
                Using OTP-based login ensures your account is safe and only
                accessible through your verified mobile number.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Login;
